import styled from 'styled-components';
import logoImage from 'assets/img/systemCheck/ic_new_logo_color_white.svg';
import warningImage from 'assets/img/systemCheck/warning_triangle.svg';

export const Wrapper = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
  margin: auto;
  background-color: #f1f3ff;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: 1200px) {
    width: 1080px;
  }
`;

export const LogoImageWrapper = styled.div`
  position: absolute;
  top: 4vh;
  height: 10%;
  width: 80%;
  display: flex;
  align-items: center;
`;

export const LogoImage = styled.div`
  width: 66px;
  height: 66px;
  background-image: url(${logoImage});
  background-size: contain;
  background-repeat: no-repeat;

  @media (min-width: 768px) {
    width: 86px;
    height: 86px;
  }

  @media (min-width: 992px) {
    width: 100px;
    height: 100px;
  }
`;

export const WarningImage = styled.div`
  margin-top: 14vh;
  margin-bottom: -3.5vh;
  width: 260px;
  height: 260px;
  background: url(${warningImage});
  background-repeat: no-repeat;
  background-size: contain;

  @media (min-width: 576px) {
    width: 320px;
    height: 320px;
    margin-bottom: -5vh;
  }

  @media (min-width: 768px) {
    width: 350px;
    height: 350px;
    margin-bottom: -5vh;
  }

  @media (min-width: 992px) {
    width: 400px;
    height: 400px;
    margin-bottom: -5vh;
  }
`;

export const Heading = styled.div`
  height: 6.4%;
  color: #666666;
  font-size: 2.1rem;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: 992px) {
    width: 80%;
    height: 9%;
    font-size: 2.6rem;
  }
`;

export const UnderLineBox = styled.div`
  width: 80%;
  height: 13px;
  background-color: white;
  margin: 5px;

  @media (min-width: 992px) {
    height: 17px;
  }
`;

export const Message = styled.div`
  width: 80%;
  margin-top: 20px;
  line-height: 29px;
  font-size: 1.3rem;
  word-break: keep-all;
  color: #666666;

  @media (min-width: 576px) {
    line-height: 31px;
    font-size: 1.4rem;
  }

  @media (min-width: 992px) {
    line-height: 35px;
    font-size: 1.5rem;
  }
`;
